import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { OrderService } from '@app/shared/services/order/order.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '@app/shared/services/common/common.service';
import { GetTranscation, ResponseData } from '@app/feature/store-admin/components/reports/order-shopify/ITranscation';
import { GetOrdersInterface } from '@app/shared/services/order/GetOrders.interface';
import { EncrDecrService } from '../../../services/encr-decr-service.service';
import { CryptoKeyValue } from '../../../constants';
import { environment } from '@env/environment';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { ClientService } from '@app/feature/super-admin/services/client/client.service';
import { APIResponse } from '@app/shared/services/core/ICore.interface';
import { OrderCancelComponent } from '../../order-cancel/order-cancel.component';
import { DesignHuddleImageService } from '@app/shared/services/design-huddle/design-huddle-image.service';
import { TransactionDetailDialogComponent } from '../../../dialogs/transaction-detail/transaction-detail.component';
import { BulkJobStatusComponent } from './bulk-job-status/bulk-job-status.component';

@Component({
  selector: "app-orders",
  templateUrl: "./orders.component.html",
  styleUrls: ["./orders.component.css"],
})
export class OrdersComponent implements OnInit {
  userId: any;
  userRole!: any;
  orderList: GetOrdersInterface[] = [];
  parentRouteParam!: any;
  orderFilterForm: FormGroup;
  orderStatusFilterId = 0;
  // For Infinite scroll of grid
  pageSize = 8; // No of items to load from server side i.e no of items to take
  initialItemsCount!: number; // No of items to skip
  isDisplay = "none";
  isDisplay1 = "block";
  isFullListDisplayed: boolean = false;
  scrollDisabled: boolean = false;
  imgBaseURL = environment.imgBaseURL;
  imgCustomBaseURL = environment.productCustomImageFolder;
  imgWareHouseBaseURL = environment.warehouseProductCustomImageFolder;
  @ViewChild("openAPIInvoiceDialog") openAPIInvoiceDialog: TemplateRef<any>;
  @ViewChild("openAPIUploadInvoiceDialog")
  openAPIUploadInvoiceDialog: TemplateRef<any>;
  invoiceForm: FormGroup;
  minDate = new Date(2021, 8, 1);
  openAPIUsers: any;
  invoiceFileUploaded = false;
  invoiceFile: File;
  invoiceFileName = "";
  invoiceFileErrorMessage: string;
  @ViewChild("invoiceFileInput") invoiceFileInput!: any;
  invoiceUploadDialogRef: MatDialogRef<any>;
  invoiceUploadForm: FormGroup;

  @ViewChild("impressInvoiceDialog") impressInvoiceDialog: TemplateRef<any>;
  impressInvoiceFileUploaded = false;
  impressInvoiceFile: File;
  impressInvoiceFileName = "";
  impressInvoiceFileErrorMessage: string;
  @ViewChild("myImpressInvoiceInput") impressInvoiceFileInput!: any;
  impressInvoiceDialogRef: MatDialogRef<any>;
  timezone: string = new Date()
    .toString()
    .split("(")
    [new Date().toString().split("(").length - 1].replace(/[^A-Z]+/g, "");

  @ViewChild("markShippedImpressDialog")
  markShippedImpressDialog: TemplateRef<any>;
  markShippedImpressFileUploaded = false;
  markShippedImpressFile: File;
  markShippedImpressFileName = "";
  markShippedImpressFileErrorMessage: string;
  @ViewChild("markShippedImpressFileInput") markShippedImpressFileInput!: any;
  markShippedImpressDialogRef: MatDialogRef<any>;

  constructor(
    private orderService: OrderService,
    private clientService: ClientService,
    private loader: LoaderService,
    private notificationService: NotificationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _fb: FormBuilder,
    private errorhandlerService: ErrorhandlerService,
    private EncrDecr: EncrDecrService,
    private commonService: CommonService,
    private dialog: MatDialog,
    private designHuddleImageService: DesignHuddleImageService
  ) {
    this.orderFilterForm = this._fb.group({
      selectedOrderStatus: new FormControl("0"),
      orderNumber: new FormControl(""),
      orderedUserName: new FormControl(""),
      orderUserEmail: new FormControl(""),
      isOrderDesk: new FormControl(false),
    });
    this.invoiceForm = this._fb.group({
      FromDate: new FormControl("", Validators.required),
      ToDate: new FormControl("", Validators.required),
      UserId: new FormControl("", Validators.required),
    });
    this.invoiceUploadForm = this._fb.group({
      chequeNo: [null, Validators.required],
      chequeAmount: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern("[1-9]\\d*(\\.\\d{0,2})?"),
        ]),
      ],
    });
  }

  ngOnInit() {
    const windowHeight = $(window).height();
    const footerHeight = $(".footer").height();
    const diff = windowHeight - footerHeight;
    $(".front-wrap").css("min-height", diff);

    this.userId = localStorage.getItem("userId");
    this.userRole = localStorage.getItem("role");
    if (this.userRole === "SuperAdmin") {
      this.userId = 0;
    }
    this.initialItemsCount = 0;
    this.orderList = [];
    if (this.activatedRoute.parent) {
      this.activatedRoute.parent.params.subscribe((params) => {
        this.parentRouteParam = params["storename"];
      });
    }
    this.fn_GetOrderListing(false); // 0 means all orders with no filtering
  }

  fn_OnResize(event: any) {
    const a = $(window).height();
    const d = $(".footer").height();
    const e = a - d;
    $(".front-wrap").css("min-height", e);
  }

  fn_clearFilter() {
    this.orderFilterForm = this._fb.group({
      selectedOrderStatus: new FormControl("0"),
      orderNumber: new FormControl(""),
      orderedUserName: new FormControl(""),
      orderUserEmail: new FormControl(""),
      isOrderDesk: new FormControl(false),
    });
    this.fn_GetOrderListing(true);
  }
  /** Func to get order listing */
  fn_GetOrderListing(status: boolean) {
    if (status) {
      // Status TRUE means status is changed, so clear the exisitng list and count
      this.initialItemsCount = 0;
      this.isFullListDisplayed = false;
      this.orderList = [];
      this.loader.show();
    } else {
      this.loader.hide();
      this.loader.lazyLoaderShow();
    }
    this.userRole = localStorage.getItem("role");
    if (this.userRole === "SuperAdmin" || this.userRole === "CustomerService") {
      this.userId = 0; // for getting all the orders, regardless of any specific user
    }
    this.scrollDisabled = true;
    this.orderService
      .GetOrders(
        this.userId,
        this.initialItemsCount,
        this.pageSize,
        Number(this.orderFilterForm.controls["selectedOrderStatus"].value),
        this.orderFilterForm.controls["orderNumber"].value,
        this.orderFilterForm.controls["orderedUserName"].value,
        this.orderFilterForm.controls["orderUserEmail"].value,
        this.orderFilterForm.controls["isOrderDesk"].value
      )
      .subscribe(
        (res) => {
          this.scrollDisabled = false;
          if (res.StatusCode === 200) {
            this.fn_AddLazyLoadedItems(res.Data.ResponseData);
            this.loader.lazyLoaderHide();
            this.loader.hide();
          } else if (res.StatusCode === 204) {
            if (this.initialItemsCount <= 0) {
              this.notificationService.error(res.Message, "Record(s)");
            }
            this.loader.lazyLoaderHide();
            this.loader.hide();
          } else {
            this.loader.lazyLoaderHide();
            this.loader.hide();
          }
        },
        (err: any) => {
          this.loader.lazyLoaderHide();
          this.loader.hide();
          this.errorhandlerService.handleError(err);
        }
      );
  }

  handleTranscationData(
    data: GetTranscation
  ): {
    orderId: string | null;
    Id: string;
    RefundedId: string | null;
    ProcessorResponseText: string;
    ProcessorResponseCode: string;
  }[] {
    return data.Data.ResponseData.map((ele: ResponseData) => {
      return {
        orderId: ele.OrderId,
        Id: ele.Id,
        RefundedId: ele.RefundedTransactionId,
        ProcessorResponseCode: ele.ProcessorResponseCode,
        ProcessorResponseText: ele.ProcessorResponseText,
      };
    });
  }

  /** Function to add new lazy loaded items to original items list */
  fn_AddLazyLoadedItems(items: any) {
    for (let i = 0; i < items.length; i++) {
      var shopifyDiscountedTotal = 0;

      // check if item with same id exists
      if (!this.orderList.find((x) => x.OrderId === items[i].OrderId)) {
        this.initialItemsCount = this.orderList.push(items[i]);

        //Reset prices according to role and application
        for (let j = 0; j < items[i].OrderItems.length; j++) {
          if (!items[i].OrderItems[j].ImageName) {
            // Check Design Huddle first
            if (items[i].OrderItems[j].AzureBlobThumbnailUrl) {
              items[i].OrderItems[j].ImageName = items[i].OrderItems[j].AzureBlobThumbnailUrl;
            } else {
              items[i].OrderItems[j].ImageName = this.imgBaseURL + items[i].OrderItems[j].PngRelativeUrlWithProduct;
            }
          } else {
            if (items[i].OrderItems[j].IsImageCustom)
              items[i].OrderItems[j].ImageName =
                this.imgCustomBaseURL + items[i].OrderItems[j].ImageName;
            else
              items[i].OrderItems[j].ImageName =
                this.imgBaseURL + items[i].OrderItems[j].ImageName;
          }

          if (items[i].IsOrderDeskOrder) {
            items[i].OrderItems[j].UnitPrice =
              items[i].OrderItems[j].UnitPrice +
              items[i].OrderItems[j].TotalPrintPrice;
            items[i].Discount = (
              (items[i].SubTotal * items[i].OrderItems[j].Discount) /
              100
            ).toFixed(2);
          } else {
            var finalCost = 0;
            var profit = 0;
            var cost = items[i].OrderItems[j].EmbroideryCost;
            var printcost = items[i].OrderItems[j].PrintingCost;
            var finishingPrice = items[i].OrderItems[j].FinishingPrice;
            var sideCount = items[i].OrderItems[j].ProductSidesCount;
            var IsEmbroideryType = items[i].OrderItems[j].IsEmbroideryType;
            if (items[i].IsSampleOrder === true) {
              if (IsEmbroideryType) {
                finalCost = this.commonService.fn_CalculateTotalCost(
                  items[i].OrderItems[j].UnitPriceWithoutProfit,
                  finishingPrice,
                  cost,
                  sideCount,
                  0,
                  IsEmbroideryType
                );
              } else {
                finalCost = this.commonService.fn_CalculateTotalCost(
                  items[i].OrderItems[j].UnitPriceWithoutProfit,
                  finishingPrice,
                  printcost,
                  sideCount,
                  0
                );
              }
              //Apply discount if has any
              if (
                items[i].OrderItems[j].Discount > 0 &&
                items[i].OrderItems[j].Discount != null
              ) {
                finalCost = this.commonService.fn_calculateDiscount(
                  finalCost,
                  items[i].OrderItems[j].Discount
                );
              }
              //No Disccount would be applicable for finshing price
              items[i].OrderItems[j].UnitPrice = finalCost;
            } else {
              if (!items[i].IsShopifyOrder) {
                profit = items[i].OrderItems[j].RetailPrice;
                if (IsEmbroideryType) {
                  finalCost = finalCost =
                    this.commonService.fn_CalculateTotalCost(
                      items[i].OrderItems[j].UnitPriceWithoutProfit,
                      finishingPrice,
                      cost,
                      sideCount,
                      profit,
                      IsEmbroideryType
                    );
                } else {
                  finalCost = this.commonService.fn_CalculateTotalCost(
                    items[i].OrderItems[j].UnitPriceWithoutProfit,
                    finishingPrice,
                    printcost,
                    sideCount,
                    profit
                  );
                }
                items[i].OrderItems[j].UnitPrice = finalCost;
              } else {
                // Shopify orders: include the store profit / retail price in the cost (was profit = 0,
                // which showed Price/Piece $0.00), and do NOT apply DiscountForStoreAdmin here (that
                // is the store-admin commission %, not a customer discount; 100% was zeroing the price).
                profit = items[i].OrderItems[j].RetailPrice;
                if (IsEmbroideryType) {
                  finalCost = finalCost =
                    this.commonService.fn_CalculateTotalCost(
                      items[i].OrderItems[j].UnitPriceWithoutProfit,
                      finishingPrice,
                      cost,
                      sideCount,
                      profit,
                      IsEmbroideryType
                    );
                } else {
                  finalCost = this.commonService.fn_CalculateTotalCost(
                    items[i].OrderItems[j].UnitPriceWithoutProfit,
                    finishingPrice,
                    printcost,
                    sideCount,
                    profit
                  );
                }
                items[i].OrderItems[j].UnitPrice = finalCost;
              }
            }

            if (items[i].IsShopifyOrder && !items[i].IsSampleOrder)
              items[i].TotalPrice = shopifyDiscountedTotal;
          }
        }

        if (items[i].IsShopifyOrder && !items[i].IsSampleOrder) {
          items[i].Discount = (
            (items[i].TotalPrice * items[i].OrderItems[0].Discount) /
            100
          ).toFixed(2);
          items[i].TotalPrice += items[i].ShippingCost;
        }

        // SOP-hosted discount summary (parity with the order-detail totals). Computed independently
        // from UnitPriceWithoutProfit + RetailPrice (profit) + shipping + sales tax, so it does not
        // depend on the mangled per-item UnitPrice above. Shown on the list only for SOP-hosted orders.
        var sopOrder = items[i];
        var subTotalWithProfit = 0;
        for (const it of (sopOrder.OrderItems || [])) {
          subTotalWithProfit += this.commonService.fn_CalculateTotalCost(
            it.UnitPriceWithoutProfit, it.FinishingPrice, it.PrintingCost,
            it.ProductSidesCount, (it.RetailPrice || 0), false, it.IsWareHouseProduct
          ) * it.Quantity;
        }
        sopOrder._subTotalWithProfit = subTotalWithProfit;
        sopOrder._salesTaxAmount = Number(sopOrder.SalesTaxAmount || 0);
        sopOrder._amountPaid = subTotalWithProfit + Number(sopOrder.ShippingCost || 0) + sopOrder._salesTaxAmount;
        sopOrder._isSopHosted = !!sopOrder.SOPHosted;
        sopOrder._sopDiscountPercent = Number(sopOrder.SopDiscountPercent || 0);
        sopOrder._sopDiscountAmount = sopOrder._amountPaid * sopOrder._sopDiscountPercent / 100;
        sopOrder._sopFinalTotal = sopOrder._amountPaid - sopOrder._sopDiscountAmount;
      }
    }

    if (items.length < this.pageSize) {
      this.isFullListDisplayed = true;
    }
    this.isDisplay = this.initialItemsCount > 0 ? "none" : "block";
  }

  RequestCancelOrder(order: any) {
    const dialogConfig: MatDialogConfig = {
      width: "600px",
      data: order,
    };
    const orderCancelDialog = this.dialog.open(
      OrderCancelComponent,
      dialogConfig
    );
    orderCancelDialog.afterClosed().subscribe((res: any) => {
      if (res && res.isSubmit) {
        this.loader.show();
        this.fn_GetOrderListing(true);
      }
    });
  }

  fn_ShowImpressBox(orderId: any) {
    var currentRow = this.orderList.find((x) => x.OrderId === orderId);
    currentRow.TempOrderNo = currentRow.OrderNo;
    currentRow.OrderNo = "";
    currentRow.ShowEditForm = true;
  }

  fn_CloseImpressForm(orderId: any) {
    var currentRow = this.orderList.find((x) => x.OrderId === orderId);
    currentRow.OrderNo = currentRow.TempOrderNo;
    currentRow.TempOrderNo = "";
    currentRow.ShowEditForm = false;
  }

  fn_SaveImpressForm(orderId: any) {
    var currentRow = this.orderList.find((x) => x.OrderId === orderId);
    if (currentRow.OrderNo == "") {
      this.notificationService.info("Please Enter Impress Order#", "Order");
    } else {
      this.loader.show();
      this.orderService
        .UpdateOrder(this.userId, orderId, -1, currentRow.OrderNo)
        .subscribe(
          (res: any) => {
            if (res.StatusCode === 200) {
              this.loader.hide();
              currentRow.TempOrderNo = "";
              currentRow.ShowEditForm = false;
              this.notificationService.success(res.Message, "Success");
            } else if (res.StatusCode === 400) {
              this.notificationService.error(res.Message, "Error");
              this.loader.hide();
            } else {
              this.notificationService.error(res.Message, "Error");
              this.loader.hide();
            }
          },
          (err: any) => {
            this.loader.hide();
            this.errorhandlerService.handleError(err);
          }
        );
    }
  }

  /** Func for redirecting to order details */
  fn_RedirectToOrderDetail(orderNo: any) {
    this.loader.show();
    if (this.userRole === "SuperAdmin" || this.userRole === "CustomerService") {
      this.router.navigate(["/superadmin/orderdetail", orderNo]);
    } else {
      this.router.navigate([this.parentRouteParam + "/orderdetail", orderNo]);
    }
  }

  /**Redireect user to vin
   * ew store screen */
  fn_ViewProduct(productId: any, designId: any, type: number) {
    var encryptedproductId = this.EncrDecr.set(
      CryptoKeyValue.Key,
      String(productId)
    );
    var encrypteddesignId = this.EncrDecr.set(
      CryptoKeyValue.Key,
      String(designId)
    );
    this.router.navigate([this.parentRouteParam + "/product/details"], {
      queryParams: {
        pid: encryptedproductId,
        designId: encrypteddesignId,
        type: type,
      },
    });
  }

  fn_CrytoEncryptDecryptText(orderid: any) {
    //return this.EncrDecr.set(CryptoKeyValue.Key, String(orderid))
    return this.EncrDecr.set(CryptoKeyValue.Key, String(orderid));
  }

  fn_GetOpenAPIUsers() {
    this.loader.lazyLoaderShow();
    this.clientService.GetOpenAPIClientList().subscribe(
      (res: any) => {
        if (res.StatusCode === 200) {
          this.openAPIUsers = res.Data.ResponseData;
          this.loader.lazyLoaderHide();
        } else if (res.StatusCode === 400) {
          this.notificationService.error(res.Message, "Try again");
        } else if (res.StatusCode === 500) {
          this.notificationService.error("An error occured", "Try again");
        }
        this.loader.lazyLoaderHide();
      },
      (err: any) => {
        this.errorhandlerService.handleError(err);
        this.loader.lazyLoaderHide();
      }
    );
  }
  fn_OpenAPIInvoiceDialog() {
    var dialogRef = this.dialog.open(this.openAPIInvoiceDialog); //{ maxWidth: '50%' } removed this part
    dialogRef.afterClosed().subscribe((result) => {
      this.invoiceForm.patchValue({
        FromDate: "",
        ToDate: "",
        UserId: "",
      });
    });
    this.fn_GetOpenAPIUsers();
  }
  FromDateEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.invoiceForm.patchValue({
      FromDate: event.value,
    });
    this.minDate = new Date(this.invoiceForm.controls.FromDate.value);
  }
  ToDateEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.invoiceForm.patchValue({
      ToDate: event.value,
    });
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.invoiceForm.controls;
  }
  displayFn(userId: number): string {
    if (this.openAPIUsers) {
      var user = this.openAPIUsers.find((x) => x.UserId == userId);
      if (user) return user.Email;
      else return "";
    } else return "";
  }
  fn_DownloadInvoice() {
    // stop here if form is invalid
    if (this.invoiceForm.invalid) {
      return;
    }

    let form = this.invoiceForm;
    let fromDate =
      form.value.FromDate !== null && form.value.FromDate !== ""
        ? form.value.FromDate.toUTCString()
        : "";
    let toDate =
      form.value.ToDate !== null && form.value.ToDate !== ""
        ? form.value.ToDate.toUTCString()
        : "";

    this.loader.show();
    this.orderService
      .DownloadOpenAPIInvoice(fromDate, toDate, form.value.UserId)
      .subscribe(
        (res) => {
          this.loader.hide();
          let filename = "Invoice.xlsx";
          var header = res.headers.get("Content-Disposition");
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(header);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
          const downloadedFile = new Blob([res.body], { type: res.body.type });
          const a = document.createElement("a");
          a.setAttribute("style", "display:none;");
          document.body.appendChild(a);
          a.download = filename;
          a.href = URL.createObjectURL(downloadedFile);
          a.target = "_blank";
          a.click();
          document.body.removeChild(a);
        },
        (err: any) => {
          this.errorhandlerService.handleError(err);
          this.loader.hide();
        }
      );
  }

  fn_OpenAPIUploadInvoiceDialog() {
    this.invoiceUploadDialogRef = this.dialog.open(
      this.openAPIUploadInvoiceDialog
    );
  }
  fileChangeEvent(event: any): void {
    this.invoiceFileErrorMessage = "";
    this.invoiceFileName = "";
    this.invoiceFileUploaded = false;
    if (event.target.files.length > 0) {
      const type = event.target.files[0].type;
      const size = event.target.files[0].size;
      if (
        type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.invoiceFileInput.nativeElement.value = "";
        this.notificationService.error("Invalid type file", "Type");
        return;
      }
      if (Math.round(size / 1024) >= 30720) {
        this.invoiceFileInput.nativeElement.value = "";
        this.notificationService.error("Size must be less than 30 Mb", "Size");
        return;
      } else {
        this.invoiceFileName = event.target.files[0].name;
        this.invoiceFile = event.target.files[0];
        this.invoiceFileUploaded = true;
      }
    }
  }
  // convenience getter for easy access to form fields
  get fu() {
    return this.invoiceUploadForm.controls;
  }
  fn_UploadInvoiceFile() {
    if (this.invoiceFile) {
      if (this.invoiceUploadForm.invalid) {
        this.notificationService.error(
          "Please provide Cheque no. and Cheque amount",
          "Validation"
        );
        return false;
      }
      this.invoiceFileErrorMessage = "";
      const formData = new FormData();
      formData.append("ChequeNo", this.invoiceUploadForm.value.chequeNo);
      formData.append(
        "ChequeAmount",
        this.invoiceUploadForm.value.chequeAmount
      );
      formData.append("File", this.invoiceFile, this.invoiceFile.name);
      this.loader.show();
      this.orderService.UploadOpenAPIInvoice(formData).subscribe(
        (res: APIResponse<any>) => {
          this.loader.hide();
          if (res.StatusCode === 200) {
            this.invoiceUploadDialogRef.close();
            this.notificationService.success(
              "Request has been submitted to Impress. Please verify in Impress. It will take time to process according to no. of records.",
              "Success"
            );
            this.invoiceFileErrorMessage = "";
            this.invoiceFileName = "";
            this.invoiceFileUploaded = false;
            this.invoiceFileInput.nativeElement.value = "";
            this.invoiceUploadForm.reset();
          } else {
            if (res.Data.ResponseData)
              this.invoiceFileErrorMessage = res.Data.ResponseData;
            else this.notificationService.error(res.Message, "Error");
          }
        },
        (err: any) => {
          this.loader.hide();
          this.errorhandlerService.handleError(err);
        }
      );
    }
  }

  // Parse the OrderListModel.ShopifyDiscounts JSON string into a list of display strings ("code: amount (type)").
  getShopifyDiscounts(json: string): string[] {
    if (!json) return [];
    try {
      const obj = JSON.parse(json);
      return Object.keys(obj).map(k => {
        const d = obj[k];
        if (d && typeof d === 'object') {
          const label = [d.code, d.amount].filter(x => x != null).join(': ');
          return d.type ? `${label} (${d.type})` : label;
        }
        return String(d);
      });
    } catch {
      return [];
    }
  }

  getDate(date, requiretimezone) {
    if (requiretimezone) {
      let options: Intl.DateTimeFormatOptions = {
        hour12: false,
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      };
      return (
        new Date(date).toLocaleDateString("en-US", options) +
        " (" +
        this.timezone +
        ")"
      );
    } else {
      let options: Intl.DateTimeFormatOptions = {
        hour12: false,
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      };
      return new Date(date).toLocaleDateString("en-US", options);
    }
  }

  fn_ImpressInvoiceDialog() {
    this.impressInvoiceDialogRef = this.dialog.open(this.impressInvoiceDialog);
  }
  impressInvoicefileChangeEvent(event: any): void {
    this.impressInvoiceFileErrorMessage = "";
    this.impressInvoiceFileName = "";
    this.impressInvoiceFileUploaded = false;
    if (event.target.files.length > 0) {
      const type = event.target.files[0].type;
      const size = event.target.files[0].size;
      if (
        type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.impressInvoiceFileInput.nativeElement.value = "";
        this.notificationService.error("Invalid type file", "Type");
        return;
      }
      if (Math.round(size / 1024) >= 30720) {
        this.impressInvoiceFileInput.nativeElement.value = "";
        this.notificationService.error("Size must be less than 30 Mb", "Size");
        return;
      } else {
        this.impressInvoiceFileName = event.target.files[0].name;
        this.impressInvoiceFile = event.target.files[0];
        this.impressInvoiceFileUploaded = true;
      }
    }
  }
  fn_ImpressInvoiceFile() {
    if (this.impressInvoiceFile) {
      this.impressInvoiceFileErrorMessage = "";
      const formData = new FormData();
      formData.append(
        "File",
        this.impressInvoiceFile,
        this.impressInvoiceFile.name
      );
      this.loader.show();
      this.orderService.UploadImpressInvoice(formData).subscribe(
        (res: APIResponse<any>) => {
          this.loader.hide();
          if (res.StatusCode === 200) {
            this.impressInvoiceDialogRef.close();
            this.notificationService.success(
              "Request has been submitted to Impress. Please verify in Impress. It will take time to process according to no. of records.",
              "Success"
            );
            this.impressInvoiceFileErrorMessage = "";
            this.impressInvoiceFileName = "";
            this.impressInvoiceFileUploaded = false;
            this.impressInvoiceFileInput.nativeElement.value = "";
          } else {
            if (res.Data.ResponseData)
              this.impressInvoiceFileErrorMessage = res.Data.ResponseData;
            else this.notificationService.error(res.Message, "Error");
          }
        },
        (err: any) => {
          this.loader.hide();
          this.errorhandlerService.handleError(err);
        }
      );
    }
  }

  fn_MarkShippedImpressDialog() {
    this.markShippedImpressDialogRef = this.dialog.open(
      this.markShippedImpressDialog
    );
  }
  markShippedImpressfileChangeEvent(event: any): void {
    this.markShippedImpressFileErrorMessage = "";
    this.markShippedImpressFileName = "";
    this.markShippedImpressFileUploaded = false;
    if (event.target.files.length > 0) {
      const type = event.target.files[0].type;
      const size = event.target.files[0].size;
      if (
        type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.markShippedImpressFileInput.nativeElement.value = "";
        this.notificationService.error("Invalid type file", "Type");
        return;
      }
      if (Math.round(size / 1024) >= 30720) {
        this.markShippedImpressFileInput.nativeElement.value = "";
        this.notificationService.error("Size must be less than 30 Mb", "Size");
        return;
      } else {
        this.markShippedImpressFileName = event.target.files[0].name;
        this.markShippedImpressFile = event.target.files[0];
        this.markShippedImpressFileUploaded = true;
      }
    }
  }
  fn_markShippedImpressFile() {
    if (this.markShippedImpressFile) {
      this.markShippedImpressFileErrorMessage = "";
      const formData = new FormData();
      formData.append(
        "File",
        this.markShippedImpressFile,
        this.markShippedImpressFile.name
      );
      this.loader.show();
      this.orderService.UploadMarkShippedImpress(formData).subscribe(
        (res: APIResponse<any>) => {
          this.loader.hide();
          if (res.StatusCode === 200) {
            this.markShippedImpressDialogRef.close();
            this.markShippedImpressFileErrorMessage = "";
            this.markShippedImpressFileName = "";
            this.markShippedImpressFileUploaded = false;
            this.markShippedImpressFileInput.nativeElement.value = "";
            // WI 1711: switch to the live status modal instead of a blanket toast.
            const jobId = (res.Data.ResponseData as any)?.jobId;
            if (jobId) {
              this.openBulkJobStatus(jobId);
            } else {
              this.notificationService.success(
                "Request submitted. Open Recent uploads to track it.",
                "Success"
              );
            }
          } else {
            // A job already running (AC #7) returns its id in ResponseData1.
            const runningId = (res.Data as any)?.ResponseData1;
            if (runningId) {
              this.markShippedImpressDialogRef.close();
              this.openBulkJobStatus(runningId);
            } else if (res.Data.ResponseData) {
              this.markShippedImpressFileErrorMessage = res.Data.ResponseData;
            } else {
              this.notificationService.error(res.Message, "Error");
            }
          }
        },
        (err: any) => {
          this.loader.hide();
          this.errorhandlerService.handleError(err);
        }
      );
    }
  }

  openBulkJobStatus(jobId: number) {
    this.dialog.open(BulkJobStatusComponent, {
      data: { jobId },
      width: "920px",
      maxWidth: "95vw",
    });
  }

  fn_openRecentUploads() {
    this.loader.show();
    this.orderService.getBulkJobs("ImpressMarkShipped", 10).subscribe(
      (res: APIResponse<any>) => {
        this.loader.hide();
        if (res.StatusCode === 200) {
          const jobs = (res.Data && res.Data.ResponseData) || [];
          this.dialog.open(BulkJobStatusComponent, {
            data: { jobs },
            width: "920px",
            maxWidth: "95vw",
          });
        } else {
          this.notificationService.error(
            res.Message || "Could not load recent uploads.",
            "Error"
          );
        }
      },
      (err: any) => {
        this.loader.hide();
        this.errorhandlerService.handleError(err);
      }
    );
  }

  getOrderImage(item: any): string {
    return this.designHuddleImageService.getCartItemImage(item);
  }

  handleTransactionDetail(transactionData: any, orderNo: any) {
    this.dialog.open(TransactionDetailDialogComponent, {
      width: '800px',
      data: {transactionData, orderNo}
    });
  }
}
